var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCfBVlFyn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2977 60.0415C69.3332 53.9837 72.3599 46.197 72.3599 37.7037C72.3599 18.3926 56.7066 2.73926 37.3955 2.73926C18.0844 2.73926 2.43103 18.3926 2.43103 37.7037C2.43103 57.0148 18.0844 72.6681 37.3955 72.6681C42.4177 72.6681 47.1866 71.6104 51.5021 69.7081",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2977 60.0415C69.3332 53.9837 72.3599 46.197 72.3599 37.7037C72.3599 18.3926 56.7066 2.73926 37.3955 2.73926C18.0844 2.73926 2.43103 18.3926 2.43103 37.7037C2.43103 57.0148 18.0844 72.6681 37.3955 72.6681C42.4177 72.6681 47.1866 71.6104 51.5021 69.7081",
    stroke: "#22BF76",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9866 42.1031L28.2685 50.2949L53.6093 25.2949",
    stroke: "#22BF76",
    strokeWidth: 6,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9718 64.9077L58.2327 64.7852",
    stroke: "#22BF76",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfBVlFyn);
export default __webpack_public_path__ + "static/media/cfBVlFYN.bedc51073216bea2071875865113db03.svg";
export { ForwardRef as ReactComponent };